import { handle } from 'redux-pack';
import {
  FETCH_ELEMENTO,
  FETCH_ELEMENTO_BY_ID,
  FETCH_ELEMENTO_BY_ID_GRAFICA,
  LIMPIAR_ESTADO_ELEMENTO,
  LOGOUT
} from '../actions/types';
import { handleAction } from '../utils/handleAction';

const initialState = {
  elementos: [],
  isLoading: false,
  error: '',
};

const ElementoReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case FETCH_ELEMENTO:
      return handleAction(state, action, {
        failure: (prevState) => ({ ...prevState, error: payload.message }),
        success: (prevState) => ({
          ...prevState,
          elementos: payload.data.data,
          total: payload.data.total
        }),
      });
    case FETCH_ELEMENTO_BY_ID:
      return handleAction(state, action, {
        failure: (prevState) => ({ ...prevState, error: payload.message }),
        success: (prevState) => ({
          ...prevState,
          elemento: payload.data,
        }),
      });
    case FETCH_ELEMENTO_BY_ID_GRAFICA:
      return handle(state, action, {
        start: (prevState) => ({ ...prevState, isLoading: false }),
        finish: (prevState) => ({ ...prevState, isLoading: false }),
        failure: (prevState) => ({ ...prevState, error: payload.message }),
        success: (prevState) => ({
          ...prevState,
          elemento: payload.data,
        }),
      });
    case LIMPIAR_ESTADO_ELEMENTO:
      return { ...initialState };
    case LOGOUT:
      return initialState;
    default:
      return state;
  }
};

export default ElementoReducer;
